import { useNavigate } from 'react-router-dom'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Flex, PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { IOpsTodayQuickLink } from 'types/opsToday.interface'
import { USE_OPS_MOCKS } from '../Shared/opsControl'
import { DemoBadge } from '../Shared/OpsSharedComponents'
import { EnvironStrip } from './EnvironStrip'
import { TodayQuestionCard } from './TodayQuestionCard'
import { TodayInbox } from './TodayInbox'
import { TodaySwitcher } from './TodaySwitcher'
import { SiteRequestsSummary } from './TodayRequests'
import { buildInboxItems, buildSiteCards } from './todayData'
import { FooterChip, FooterRow, QuestionsGrid, TodayTitle } from './OpsToday.styled'

const QUICK_LINKS: IOpsTodayQuickLink[] = [
  { label: 'Full timeline', path: '/operations/timeline' },
  { label: 'My departments', path: '/operations/department' },
  { label: 'Handover report', path: '/operations/handover' },
  { label: 'Overview', path: '/operations/overview' },
]

export const OpsToday = () => {
  const navigate = useNavigate()

  if (!USE_OPS_MOCKS) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <NoData text='Your shift view will come alive once the site is connected.' />
        </PageWrapper>
      </>
    )
  }

  const cards = buildSiteCards()

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex center gap='0.75rem'>
          <TodayTitle>Today</TodayTitle>
          <DemoBadge />
        </Flex>
        <OtherText grey>Day Shift · 06:00–18:00</OtherText>
        <TodaySwitcher activeKey='site' />
        <EnvironStrip />
        <QuestionsGrid>
          {cards.map((card) => (
            <TodayQuestionCard key={card.id} card={card} />
          ))}
        </QuestionsGrid>
        <TodayInbox initialItems={buildInboxItems()} />
        <SiteRequestsSummary />
        <FooterRow>
          {QUICK_LINKS.map((link) => (
            <FooterChip key={link.path} onClick={() => navigate(link.path)}>
              {link.label}
            </FooterChip>
          ))}
        </FooterRow>
      </PageWrapper>
    </>
  )
}
